/*
* Salla Rating Stars Component: Rating starts as rating input or to display rating values.
* You can use these classes to target the elements in the component.
*/

.s-rating-stars{
  &-wrapper{

  }
  &-btn-star{

  }
  &-large{
    
  }
  &-medium{
    
  }
  &-small{
    
  }
  &-hovered{
    
  }
  &-selected{

  }
}